const URL = 'http://localhost:4000/rest/profiles';

export const findAllProfiles = () =>
  fetch(URL)
  .then(response => response.json());

export const updateProfile = (profile) =>
  fetch(`${URL}/${profile._id}`, {
    method: 'PUT',
    body: JSON.stringify(profile),
    headers: {
      'content-type': 'application/json'
    }
  }).then(response => response.json());

export default {
  findAllProfiles, updateProfile
};
